class RedirectController {
    static RedirectClient(url, delay) {
        setTimeout(() => {
            window.location.href = url;
        }, delay);
    }
}

window.RedirectController = RedirectController;
export default RedirectController;

// #endregion
